<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    fill="none"
    :width="widthAttr"
    :height="heightAttr"
    overflow="visible"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M15 21H25C28.1509 21 30.8174 23.3276 31.2431 26.4496L31.5356 28.5947C31.7595 30.2363 30.6101 31.7486 28.9685 31.9725C28.8342 31.9908 28.6987 32 28.5631 32H11.4369C9.78 32 8.43686 30.6569 8.43686 29C8.43686 28.8644 8.44605 28.729 8.46437 28.5947L8.75688 26.4496C9.18261 23.3276 11.8491 21 15 21Z"
      fill="#172983"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M20 19C22.7614 19 25 15.7683 25 12.4545C25 9.14084 22.7614 7 20 7C17.2386 7 15 9.14084 15 12.4545C15 15.7683 17.2386 19 20 19Z"
      fill="#172983"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M1 0C0.447 0 0 0.448 0 1V9C0 9.552 0.447 10 1 10H10L14 14V1C14 0.448 13.553 0 13 0H1Z"
      fill="#2DB8D2"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5 5C5 5.552 4.553 6 4 6C3.447 6 3 5.552 3 5C3 4.448 3.447 4 4 4C4.553 4 5 4.448 5 5Z"
      fill="white"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8 5C8 5.552 7.553 6 7 6C6.447 6 6 5.552 6 5C6 4.448 6.447 4 7 4C7.553 4 8 4.448 8 5Z"
      fill="white"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11 5C11 5.552 10.553 6 10 6C9.447 6 9 5.552 9 5C9 4.448 9.447 4 10 4C10.553 4 11 4.448 11 5Z"
      fill="white"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M20 26C22.7614 26 25 23.7614 25 21H15C15 23.7614 17.2386 26 20 26Z"
      fill="white"
      fill-opacity="0.4"
    />
  </svg>
</template>

<script>
export default {
  name: 'IconsLargeSize32pxSignUpPublicViewerColor',

  props: {
    width: {
      type: String,
      required: false,
    },

    height: {
      type: String,
      required: false,
    },

    size: {
      type: String,
      required: false,
    },
  },

  computed: {
    widthAttr() {
      if (this.height) return undefined;
      if (this.size) return this.size;
      return this.width || '32px';
    },

    heightAttr() {
      if (this.width) return undefined;
      if (this.size) return this.size;
      return this.height || '32px';
    },
  },
};
</script>
